import { useQuery } from '@tanstack/react-query';

import { useOrganizationStore } from '@/store/organization-store';
import { listTeamPlayersController } from '@/interface-adapters/controllers/list-team-players.controller';
import { SearchParams } from '@/entities/SearchParams';

export const useTeamLeagueTeamPlayersQuery = (teamUuid: string, searchParams?: SearchParams) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['TEAM_LEAGUE_TEAM_PLAYERS', store.organizationUuid, store.teamLeagueUuid, teamUuid],
		queryFn: () => listTeamPlayersController(store.organizationUuid, store.teamLeagueUuid, teamUuid, searchParams),
		enabled: !!(store.organizationUuid && store.teamLeagueUuid && teamUuid)
	});
};
